import styled from "styled-components";
import Container from "../../Components/Container";

const ProductPageStyle = styled(Container)`
    width : 80%;
    max-width:unset;
    position:relative;

    .accordion-wrapper{
        color:white;
        flex-basis:50%;
        cursor : unset;

        div{
            cursor : unset;
        }
        ul{
            padding : revert;
            list-style : unset;
        }

        

        ol{
            list-style : auto;
            padding : revert;
        }
    }

    .accordion-wrapper * {
        font-size : inherit !important;
        font-family : inherit !important;
    }

    .accordion-header{
        cursor : pointer!important;
    }

    .accordion-header > h3{
        border-bottom : solid 1px #707070;
        width : 100%;
        padding : 5px;
        
    }

    .accordion-section h5 {
        padding : 6px;
    }
    
    .accordion-section{
        gap:1rem;
        
    }

    @media only screen and (min-width: 1980px) and (max-width: 2720px) {
        margin-top : 9rem;
    }

    

    @media only screen and (min-width: 1980px) {
       

        .accordion-header > h3{
            font-size : 1.2vw;
        }

        .accordion-wrapper  h5{
            font-size : 0.8vw;
        }
    }

    @media only screen and (max-width: 1440px) {
        width : 98%;
    }

    @media only screen and (max-width: 914px) {
       margin-top:5.5rem;

       .accordion-section{
        flex-direction : column;
       }
    }

    @media only screen and (max-width: 517px) {
        width:96%;
     }

`

export default ProductPageStyle